import React from 'react';
import styles from './skeletonLoader.module.css';

const SkeletonLoader: React.FC = () => (
  <div className={styles.skeleton}>
    {/* Scorecard placeholders */}
    <div className={styles.scorecardsRow}>
      <div className={styles.scorecardBlock} />
      <div className={styles.scorecardBlock} />
      <div className={styles.scorecardBlock} />
    </div>

    {/* Chart placeholder */}
    <div className={styles.chartBlock} />

    {/* Tables row placeholder */}
    <div className={styles.tablesRow}>
      <div className={styles.tableBlock} />
      <div className={styles.tableBlock} />
    </div>
  </div>
);

export default SkeletonLoader;
